import React from "react";
import "./TipoListaSelector.css";

const TipoListaSelector = ({ value, onChange }) => {
  return (
    <div className="tipo-lista-selector" role="radiogroup" aria-label="Tipo de listagem">
      <label className={`tipo-lista-option ${value === "grupo" ? "active" : ""}`}>
        <input
          type="radio"
          name="tipo-lista-auditoria"
          value="grupo"
          checked={value === "grupo"}
          onChange={() => onChange("grupo")}
        />
        Grupo
      </label>
      <label className={`tipo-lista-option ${value === "questao" ? "active" : ""}`}>
        <input
          type="radio"
          name="tipo-lista-auditoria"
          value="questao"
          checked={value === "questao"}
          onChange={() => onChange("questao")}
        />
        Questão
      </label>
    </div>
  );
};

export default TipoListaSelector;
